export { default as AutoDetail } from './AutoDetail.vue'
export { default as AutoEditTable } from './AutoEditTable.vue'
export { default as AutoForm } from './AutoForm.vue'
export { default as AutoTable } from './AutoTable.vue'



// WEBPACK FOOTER //
// ./client/src/components/auto/index.js